<template>
    <section>
        <FormulateForm
            class="ui_fullsize"
            v-model="formValues"
            @submit="handleChecklist"
        >
            <FormulateInput
                type="text"
                label="Title"
                name="title"
                validation="required"
                :wrapper-class="[]"
            />
            <FormulateInput
                type="select"
                label="Category"
                name="category"
                :options="tags"
                validation="required"
                placeholder="Select a category"
            />
            <FormulateInput
                type="textarea"
                label="Description"
                name="description"
                :wrapper-class="[]"
            />
            <FormulateInput
                type="group"
                name="items"
                :repeatable="true"
                label="List Items"
                add-label="+ Add another item"
                validation="min:1,length"
            >
                <div>
                <FormulateInput
                    name="item"
                    validation="required"
                />
                </div>
            </FormulateInput>
            <FormulateInput
                type="group"
                >
                <FormulateInput
                    type="submit"
                    :label="submitLabel"
                />
                <template  v-if="this.id && this.slug">
                    <router-link :to="{name: 'ChecklistDetail', params: {id:this.id, slug:this.slug}}">
                        &larr; Go back without saving
                    </router-link>
                </template>
            </FormulateInput>

        </FormulateForm>
    </section>
</template>

<script>
import axios from 'axios'

// const headers = {
//     'Authorization': `token ${this.$store.getters.getUserToken}`,
// }


const checklistApiUrl = `${process.env.VUE_APP_API_ROOT}/api/checklist/checklists/`;

export default {
    name: 'ChecklistCreate',
    components: {
    },
    props: [
        'id',
        'slug',
    ],
    data: function(){
        return {
            userToken: this.$store.getters.getUserToken,
            tags: [],
            fallbackTag: {
                id: "vue_fallback_tag",
                name: "🥚 (No Category)"
            },
            checklistId: undefined,
            checklistCategory: this.fallbackTag,
            formValues: {},
        }
    },
    computed: {
        headers: function() {
            return {
                'headers': {
                    'Authorization': `token ${this.$store.getters.getUserToken}`,
                }
            }
        },
        submitLabel: function() {
            if (this.id) {
                return "Save list"
            } else {
                return "Create list"
            }
        }
    },
    mounted() {
        // Get all tags
        fetch(`${process.env.VUE_APP_API_ROOT}/api/checklist/tags/`, {
                method: "GET",
                headers: {
                    Authorization: `token ${process.env.VUE_APP_API_TOKEN}`
                }
            })
                .then(response => response.json())
                .then(data => {
                    console.log(data)
                    data.forEach(tag => this.tags.push({"value": tag.id, "label": tag.name}));
                })
                .catch(error => {
                    console.log(error)
                    this.tags = [{"value": this.fallbackTag.id, "label": this.fallbackTag.name}]
                })


        if (this.id) {
            fetch(`${process.env.VUE_APP_API_ROOT}/api/checklist/checklists/${this.id}/`, {
                method: "GET",
                headers: {
                    Authorization: `token ${process.env.VUE_APP_API_TOKEN}`
                }
            })
                .then(response => response.json())
                .then(data => {
                    this.formValues = data
                    // Adjust tag select
                    if (data.tags.length > 0) {
                        // NOTE: 2021-02-25:
                        // Only use first tag until I allow multiple tags
                        this.tags.forEach(tag => {
                            if (tag.value == data.tags[0].id) {
                                this.formValues.category = tag.value
                            }
                        })
                    }
                })
                .catch(error => console.log(error)) //TODO: Better error handling on wrong id
        }
    },
    methods: {
        handleChecklist() {
            const payload = {
                title: this.formValues.title,
                description: this.formValues.description,
                items: this.formValues.items,
                tags: [this.formValues.category]
            }
            if (this.id) {
                this.updateChecklist(payload)
            } else {
                this.createChecklist(payload)
            }
        },
        createChecklist(payload) {
            axios
                .post(checklistApiUrl, payload, this.headers)
                .then(response => {
                    // TODO: Add success message

                    this.$router.push({
                        name: 'ChecklistDetail',
                        params: {
                            id:response.data.id,
                            slug:response.data.slug
                        }
                    });
                });
        },
        // TODO: Maybe use this for edit checklist?
        updateChecklist(payload) {
            axios
                .patch(`${checklistApiUrl}${this.id}/`, payload, this.headers)
                .then(response => {
                    // TODO: Add success message

                    this.$router.push({
                        name: 'ChecklistDetail',
                        params: {
                            id:response.data.id,
                            slug:response.data.slug
                        }
                    });
                });
        },
    }
}
</script>